module.exports = __webpack_public_path__ + "media/images/landing/data/cyber-7039fd7b74ce7425b680369e73b2449e.png";